import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./components/Layout/Layout";
import HomePage from "./pages/Home";
import FinanceDesk from "./pages/FinanceDesk";
import FinanceAdminDesk from "./pages/FinanceAdminDesk";
import ReimbursementPage from "./pages/ReimbursementPage";
import ReimbursementV2ProcessingPage from "./pages/ReimbursementV2Processing";
import InvoicePage from "./pages/Invoice";
import InvoiceV2ProcessingPage from "./pages/InvoiceV2Processing";
import LeavePage from "./pages/Leave";
import ReservationsPage from "./pages/Reservations";
import CalendarPage from "./pages/Calendar";
import TimeTrackingPage from "./pages/TimeTracking";
import UserManagementPage from "./pages/UserManagement";
import UserProfilePage from "./pages/UserProfile";
import ConfigurationPage from "./pages/Configuration";
import UnauthorizedPage from "./pages/Unauthorized";
import LoginPage from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import RootRoute from "./components/RootRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { WorkStatusProvider } from "./contexts/WorkStatusContext";
import { BadgeRefreshProvider } from "./contexts/BadgeRefreshContext";
import { DockProvider } from "./contexts/DockContext";
import { DrawerProvider } from "./contexts/DrawerContext";
import { DisplayModeProvider } from "./contexts/DisplayModeContext";
import { LinkOrderProvider } from "./contexts/LinkOrderContext";
import "./utils/i18n";

function App() {
  return (
    <ThemeContextProvider>
      <Router basename="/">
        <DockProvider>
          <DrawerProvider>
            <DisplayModeProvider>
              <LinkOrderProvider>
              <AuthProvider>
                <BadgeRefreshProvider>
                  <WorkStatusProvider>
                    <Routes>
                      <Route path="/login" element={<LoginPage />} />
                      <Route
                        path="/unauthorized"
                        element={<UnauthorizedPage />}
                      />
                      <Route path="/" element={<RootRoute />} />
                      <Route
                        path="/home"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <HomePage />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/finance-desk"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <FinanceDesk />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/finance-admin-desk"
                        element={
                          <AdminRoute>
                            <Layout>
                              <FinanceAdminDesk />
                            </Layout>
                          </AdminRoute>
                        }
                      />
                      <Route
                        path="/reimbursements"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <ReimbursementPage />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/reimbursements-v2-processing"
                        element={
                          <AdminRoute>
                            <Layout>
                              <ReimbursementV2ProcessingPage />
                            </Layout>
                          </AdminRoute>
                        }
                      />
                      <Route
                        path="/invoices"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <InvoicePage />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/invoices-v2-processing"
                        element={
                          <AdminRoute>
                            <Layout>
                              <InvoiceV2ProcessingPage />
                            </Layout>
                          </AdminRoute>
                        }
                      />
                      <Route
                        path="/leave"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <LeavePage />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/reservations"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <ReservationsPage />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/calendar"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <CalendarPage />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/timetracking"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <TimeTrackingPage />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/users"
                        element={
                          <AdminRoute>
                            <Layout>
                              <UserManagementPage />
                            </Layout>
                          </AdminRoute>
                        }
                      />
                      <Route
                        path="/profile"
                        element={
                          <ProtectedRoute>
                            <Layout>
                              <UserProfilePage />
                            </Layout>
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/configurations"
                        element={
                          <AdminRoute>
                            <Layout>
                              <ConfigurationPage />
                            </Layout>
                          </AdminRoute>
                        }
                      />
                    </Routes>
                  </WorkStatusProvider>
                </BadgeRefreshProvider>
              </AuthProvider>
              </LinkOrderProvider>
            </DisplayModeProvider>
          </DrawerProvider>
        </DockProvider>
      </Router>
    </ThemeContextProvider>
  );
}

export default App;
